import { render, staticRenderFns } from "./StationBox.vue?vue&type=template&id=27cfb0da&"
import script from "./StationBox.vue?vue&type=script&lang=js&"
export * from "./StationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports